var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.8V12.2C15 14.2 14.2 15 12.2 15H9.8C7.8 15 7 14.2 7 12.2V9.8C7 7.8 7.8 7 9.8 7H12.2C14.2 7 15 7.8 15 9.8Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.093 3.03989C11.105 2.95733 11.1834 2.89759 11.2634 2.92123C12.4372 3.26794 13.2882 4.35611 13.2882 5.64019V6.19424C12.8881 6.06216 12.411 6 11.85 6H9.15C6.9 6 6 7 6 9.5V12.5C6 13.2747 6.08643 13.9054 6.27267 14.4069H5.54818C3.98151 14.4069 2.71484 13.1335 2.71484 11.5735V5.64019C2.71484 4.35645 3.56532 3.26851 4.73287 2.9215C4.81289 2.89771 4.8914 2.95746 4.90342 3.04007C5.01942 3.83741 5.71592 4.45352 6.54151 4.45352H9.4615C10.2872 4.45352 10.9778 3.83731 11.093 3.03989Z",
    fill: "#1080FF",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54083 3.65375H9.46085C9.91419 3.65375 10.2875 3.29375 10.3009 2.84042C10.3075 2.82709 10.3075 2.81375 10.3075 2.80042V2.44042C10.3075 1.97375 9.92752 1.59375 9.46085 1.59375H6.54083C6.07417 1.59375 5.6875 1.97375 5.6875 2.44042V2.80042C5.6875 2.81375 5.6875 2.82042 5.69417 2.83376C5.7075 3.29375 6.0875 3.65375 6.54083 3.65375Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/Paste.119e766a0024f386eac9703ad7a15383.svg";
export { ForwardRef as ReactComponent };